// Mirrors backend/src/utils/locations.ts. A saved location only counts as an address when it is
// a physical one: street address, city, state and ZIP. A name or a bare city is not enough, and a
// PO box is not a place anything can be collected from or shipped from.

export interface AddressLike {
  name?: string
  address?: string
  city?: string
  state?: string
  zip?: string
  isDefault?: boolean
}

const PO_BOX = /^\s*(p\.?\s*o\.?\s*box|post\s+office\s+box)\b/i

// What is wrong with one location, in plain words; empty when it is a physical address.
export function addressProblems(entry: AddressLike | null | undefined): string[] {
  const problems: string[] = []
  const street = entry?.address?.trim() || ''
  if (!street) problems.push('a street address')
  else if (PO_BOX.test(street)) problems.push('a street address (PO boxes cannot be used)')
  if (!entry?.city?.trim()) problems.push('a city')
  if (!entry?.state?.trim()) problems.push('a state')
  if (!entry?.zip?.trim()) problems.push('a ZIP code')
  return problems
}

export const isPhysicalAddress = (entry: AddressLike | null | undefined): boolean =>
  addressProblems(entry).length === 0

export const hasPhysicalAddress = (list: AddressLike[] | null | undefined): boolean =>
  Array.isArray(list) && list.some(isPhysicalAddress)
